import "./EcoConsciousPrinting.module.css";
import Header from "@/reusable_sections/Header";
import Mission from "./sections/Mission";
import EcoCommitment from "./sections/EcoCommitment";
import Partners from "./sections/Partners";
import Footer from "@/reusable_sections/Footer";
export default function EcoConsciousPrintingPage() {
  return <div>
      <Header />
      <Mission />
      <EcoCommitment />
      <Partners />
      <Footer />
    </div>;
}